"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetbankHero = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var NetbankHero = function (props) {
    return (React.createElement("div", { className: "netbank-hero" },
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-12" },
                    React.createElement("div", { className: "gutter-px d-sm-flex flex-sm-column d-md-flex flex-md-row" },
                        React.createElement("div", { className: "hero-heading" },
                            React.createElement("h1", null, props.heading)),
                        React.createElement("div", { className: "hero-intro" }, props.intro)))))));
};
exports.NetbankHero = NetbankHero;
exports.NetbankHero.defaultProps = {};
exports.NetbankHero.propTypes = {
    heading: PropTypes.string.isRequired,
    intro: PropTypes.any.isRequired,
};
